<mat-sidenav-container class="example-container" >
    <mat-sidenav #sidenav mode="side" opened class="example-sidenav" >
        <div fxFlex fxLayout="column" >
        <div class="sidenav-img">
            <img src="assets/side-nav-logo.png"/>
        </div>
            <mat-list role="list" >
                <mat-list-item role="listitem" >
                    <img src = "assets/vector.svg" class="list-img" />
                    <span fxFlex>Insights</span>
                </mat-list-item>
                <mat-list-item role="listitem">
                    <img src = "assets/bots-icon.svg" class="list-img" />
                    <span fxFlex>Bots</span>
                </mat-list-item>
                <mat-list-item role="listitem">
                    <img src = "assets/templates-icon.svg" class="list-img"  />
                    <span fxFlex>Templates</span>
                </mat-list-item>
                <mat-list-item role="listitem">
                    <img src = "assets/pricing-icon.svg" class="list-img"  />
                    <span fxFlex>Pricing</span>
                </mat-list-item>
                <mat-list-item role="listitem">
                    <img src = "assets/policies-icon.svg" class="list-img" />
                    <span fxFlex>Policies</span>
                </mat-list-item>
                <mat-list-item role="listitem">
                    <img src = "assets/documents-icon.svg" class="list-img" />
                    <span fxFlex>Documents</span>
                </mat-list-item>
              </mat-list>
            
            </div>
    </mat-sidenav>
    
  </mat-sidenav-container>
  <!-- <div class="view-offer-section" fxFlex fxLayout="column" fxLayoutAlign="space-around space-around ">
                <div  fxLayout="row" fxFlex fxLayoutAlign="center center">
                    <img src="assets/special-offer.svg" style="margin-top: -20%;background: #FFF9E5;" />
                </div>
                <div fxLayout="row" fxFlex fxLayoutAlign="start center ">
                    <span fxFlex="80">
                        Extra savings on new trending templates
                    </span>
                </div>
                <a href="#" fxLayout="row" fxFlex fxLayoutAlign="start center">
                    View Offer
                </a>
            </div> -->
    <!-- <mat-sidenav-content class="sidenav-content">
        <mat-toolbar style="border-bottom: 1px solid rgb(231, 230, 230);padding: 1% ;margin:0 2%;width: 95%;" >
            <div class="form-group">
                <div class="input-icons">
                    <mat-icon class="search-icon">Search</mat-icon>
                <input type="email" class="form-control" style="width: 400px;padding-left: 40px;border-radius: 10px;" placeholder="Search">
                </div>
              </div>
            <span class="example-spacer"></span>
            <div fxFlex="50" fxLayout="row" fxLayoutAlign="space-around center" >
            <div class="header-div" fxLayout="column" fxLayoutAlign="space-around space-around ">
                <span>Wallet balance</span>
                <div fxLayout="row" >
                    <label>10,000</label>
                    <a href="#">Add Money</a>
                </div>
            </div>
            <div class="header-div" fxLayout="column" fxLayoutAlign="space-around space-around ">
                <mat-icon>notifications</mat-icon>
            </div>
            <div class="header-div" fxLayout="column" fxLayoutAlign="space-around space-around ">
                <span>Wallet balance</span>
                <div fxLayout="row" >
                    <label>10,000</label>
                    <a href="#">Add Money</a>
                </div>
            </div>
        </div>
          </mat-toolbar>
    </mat-sidenav-content> -->
